module.exports = __webpack_public_path__ + "static/media/art5.3c8354ff.jpg";